import React from "react";
import PropTypes from "prop-types";
import {Box} from "@mui/material";
import {FormattedMessage, useIntl} from "react-intl";

import StatCard from "components/dashboard/StatCard";
import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import MobileCarousel from "components/MobileCarousel";

function Stats({ordersData, loading, currency, isOrganizationDashboard = false}) {
    const intl = useIntl();

    const online = ordersData?.online ?? {};

    // orders
    const totalOrders = online.countTotal ?? 0;
    const evolutionOrders = ordersData?.evolutionOrders ?? null;

    // cart
    const averageCart = totalOrders > 0 ? (ordersData?.potentialTurnover ?? 0) / totalOrders : 0;
    const evolutionAverageCart = ordersData?.evolutionAverageCart ?? null;

    // turnover
    const potentialTurnover = ordersData?.potentialTurnover ?? 0;

    function formatEvolution(value) {
        if (value === null || value === undefined) {
            return undefined;
        }

        const sign = value > 0 ? "+" : "";

        return `${sign}${value.toFixed(1)}%`;
    }

    const cardOrders = (
        <StatCard
            label={<FormattedMessage id="dashboard.card.title.orders"/>}
            value={totalOrders.toLocaleString()}
            evolutionLabel={formatEvolution(evolutionOrders)}
            evolutionPositive={evolutionOrders !== null && evolutionOrders > 0}
            segmentAverage={<FormattedMessage id={isOrganizationDashboard ? 'dashboard.card.subtitle.orders.organization' : 'dashboard.card.subtitle.orders'} />}
            loading={loading}
            tooltip={intl.formatMessage({id: "dashboard.tooltip.orders"})}
        />
    );
    const cardAverageCart = (
        <StatCard
            label={<FormattedMessage id="dashboard.card.title.averageCart"/>}
            value={<FormattedNumberWithCurrency value={averageCart} currency={currency} />}
            evolutionLabel={formatEvolution(evolutionAverageCart)}
            evolutionPositive={evolutionAverageCart !== null && evolutionAverageCart > 0}
            segmentAverage={<FormattedMessage id="dashboard.card.subtitle.averageCart"/>}
            loading={loading}
            tooltip={intl.formatMessage({id: "dashboard.tooltip.averageCart"})}
        />
    );
    const cardCaPotentiel = (
        <StatCard
            label={<FormattedMessage id="dashboard.card.title.caPotentiel"/>}
            value={<FormattedNumberWithCurrency value={potentialTurnover} currency={currency} />}
            segmentAverage={<FormattedMessage id="dashboard.card.subtitle.caPotentiel"/>}
            loading={loading}
            tooltip={intl.formatMessage({id: "dashboard.tooltip.caPotentiel"})}
        />
    );

    return (
        <>
            <MobileCarousel>
                {cardOrders}
                {cardAverageCart}
                {cardCaPotentiel}
            </MobileCarousel>

            <Box sx={{ display: { xs: 'none', md: 'block' }, overflowX: "auto", pb: 0.5 }}>
                <Box sx={{ display: "flex", gap: 2, minWidth: "fit-content" }}>
                    {cardOrders}
                    {cardAverageCart}
                    {cardCaPotentiel}
                </Box>
            </Box>
        </>
    );
}

Stats.propTypes = {
    ordersData: PropTypes.object,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    isOrganizationDashboard: PropTypes.bool,
};

export default Stats;
